import { Grid, Box, Select, MenuItem } from "@mui/material";
import AdminApi from "../../../config/apis/admin";
import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import FilterBase from "../../../components/filter/filter-base";
import CSVDownloadButton from "../../../components/downloadCSV";
import { TransactionsGrid } from "./transactionsTable";
import { HasPermission } from "../../../helper/helperFunction";
import SelectOptionsApi from "../../../components/SelectApi";

export default function ViewTransactions() {
  const [filters, setFilters] = useState();
  const [locationId, setLocationId] = useState();
  const [filterTrigger, setFilterTrigger] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const isInitialLocationMount = useRef(true);

  const handleFiltersChange = (filterState) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("page", "1");
    navigate(
      { pathname: location.pathname, search: searchParams.toString() },
      { replace: true },
    );
    setFilters({
      ...filterState,
      ...(locationId ? { campus_location: locationId } : {}),
    });
    setFilterTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    if (isInitialLocationMount.current) {
      isInitialLocationMount.current = false;
      return;
    }
    setFilters((prevFilters) => {
      const updated = { ...(prevFilters || {}) };
      if (locationId) {
        updated.campus_location = locationId;
      } else {
        delete updated.campus_location;
      }
      return updated;
    });
    setFilterTrigger((prev) => prev + 1);
  }, [locationId]);

  const [currentValue, setCurrentValue] = useState("desc");

  const handleChange = (event) => {
    const newValue = event.target.value;
    setCurrentValue(newValue);
  };

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div className="container transaction_module">
        <div className="course-content">
          <h1 className="main-heading">Transactions</h1>
          <HasPermission permission="manage-transactions.create">
            <Box className="btn-wrapper">
              <Link
                to={"#"}
                onClick={() => {
                  setModalOpen(true);
                }}
              >
                Add Transactions
              </Link>
            </Box>
          </HasPermission>
        </div>

        <Grid container marginBottom={2}>
          <Grid item xl={8.5} xs={12}>
            <FilterBase onFiltersChange={handleFiltersChange} />
          </Grid>
          <Grid
            item
            xl={3.5}
            xs={12}
            marginTop={{ xl: 0, xs: 2 }}
            display="flex"
            justifyContent="flex-end"
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Box sx={{ minWidth: 150, flexShrink: 1 }}>
                <SelectOptionsApi
                  apiEndpoint={AdminApi.LOCATION_PAGINATE}
                  formData={{ location_id: locationId }}
                  onUpdate={(name, value) => setLocationId(value || undefined)}
                  labelKey="name"
                  name="location_id"
                  valueKey="id"
                  defaultText="Select Location"
                />
              </Box>

              <CSVDownloadButton
                apiEndpoint={AdminApi.TRANSACTIONS_CSV}
                params={currentValue}
                fileName={"Transactions"}
                filters={filters}
              />

              <Select
                value={currentValue}
                onChange={handleChange}
                sx={{
                  height: "43px",
                  minWidth: 130,
                  flexShrink: 0,
                }}
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </Select>
            </Box>
          </Grid>
        </Grid>

        <TransactionsGrid
          key={filterTrigger}
          filters={filters}
          currentValue={currentValue}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />
      </div>
    </>
  );
}